module.exports = __webpack_public_path__ + "static/media/timelapse_33.e795676a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_33.jpg
// module id = 991
// module chunks = 0